import React from "react";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";


import {GamePlayPcHeaderBarTopMiddleSectionComponent} from "./parts/sections/top-section/middle/game-play-pc-header-bar-top-middle-section.component";
import {GamePlayPcHeaderBarTopRightSectionComponent} from "./parts/sections/top-section/right/game-play-pc-header-bar-top-right-section.component";
import {CyClass} from "../../../../../../common/cy-classes";
import {GamePlayPcHeaderBarRootBox} from "./boxes/root/game-play-pc-header-bar-root.box";
import {GamePlayPcHeaderBarTopSectionBox} from "./boxes/sections/top-section/game-play-pc-header-bar-top-section.box";
import {
    GamePlayPcHeaderBarTopLeftSectionComponent
} from "./parts/sections/top-section/left/game-play-pc-header-bar-top-left-section.component";

interface GamePlayPcHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
    hideVendorSessionId?: boolean;
    renderTopSection?: () => React.ReactElement;
    renderTopLeftSection?: () => React.ReactElement;
    renderTopMiddleSection?: () => React.ReactElement;
    renderTopRightSection?: () => React.ReactElement;
    renderBottomSection?: () => React.ReactElement;
}

export const GamePlayPcHeaderBarComponent = observer(
    class GamePlayPcHeaderBarComponent extends OrbitComponent<GamePlayPcHeaderBarComponentProps> {
        private _captureRootElementRef = (element: HTMLElement) => {
            if(element) {
                this.props.gameContext.gameParts.headerBarRenderer?.setGamePartElementRef(element);
            }
        }

        private _renderTopLeftSection = () => {
            if(this.props.renderTopLeftSection) {
                return this.props.renderTopLeftSection();
            }

            return (
                <GamePlayPcHeaderBarTopLeftSectionComponent gameContext={this.props.gameContext} hideVendorGameSession={this.props.hideVendorSessionId}/>
            );
        }

        private _renderTopMiddleSection = () => {
            if(this.props.renderTopMiddleSection) {
                return this.props.renderTopMiddleSection();
            }

            return (
                <GamePlayPcHeaderBarTopMiddleSectionComponent gameContext={this.props.gameContext}/>
            );
        }

        private _renderTopRightSection = () => {
            if(this.props.renderTopRightSection) {
                return this.props.renderTopRightSection();
            }

            return (
                <GamePlayPcHeaderBarTopRightSectionComponent gameContext={this.props.gameContext}/>
            );
        }

        private _renderTopSection = () => {
            if(this.props.renderTopSection) {
                return this.props.renderTopSection();
            }

            return (
                <GamePlayPcHeaderBarTopSectionBox>
                    {this._renderTopLeftSection()}
                    {this._renderTopMiddleSection()}
                    {this._renderTopRightSection()}
                </GamePlayPcHeaderBarTopSectionBox>
            );
        }

        private _renderBottomSection = () => {
            if(this.props.renderBottomSection) {
                return this.props.renderBottomSection();
            }

            return null;
        }

        render() {
            return (
                <GamePlayPcHeaderBarRootBox className={CyClass('cy-game-navbar')}
                                            ref={this._captureRootElementRef}>
                    {this._renderTopSection()}
                    {this._renderBottomSection()}

                </GamePlayPcHeaderBarRootBox>
            );
        }
    }
);